import { createFileRoute } from '@tanstack/react-router'
import { RelationTypeDetailPage } from '../../../components/relation-types/RelationTypeDetailPage'

export const Route = createFileRoute('/$org/relation-types/$relationTypeUid')({
    component: RelationTypeDetailPage,
})
